export default "assets/images/logo_white-ca8494d0.png";